import { useState, type Dispatch, type SetStateAction } from "react";

/**
 * Like `useState`, but resets to `initialValue` whenever `resetKey` changes
 * (compared by reference). Callers must ensure `resetKey` is referentially
 * stable when no reset is intended (e.g. a string id, or a memoised object).
 */
export function useResetState<T>(
  initialValue: T,
  resetKey: unknown,
): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState(initialValue);
  const [prevResetKey, setPrevResetKey] = useState(resetKey);

  if (prevResetKey !== resetKey) {
    setPrevResetKey(resetKey);
    setState(initialValue);
  }

  return [state, setState];
}
